import React, { useEffect, useRef } from "react";
import X from "lucide-react";

const WorkOrder = ({ contractors, onClose, handleOpenWorkOrder }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleMouseDown = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleMouseDown);
    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, [onClose]);
  return (
    <div className="fixed inset-0 bg-[black] flex items-center bg-opacity-30 z-50">
      <div
        ref={modalRef}
        className="absolute top-[130px] right-[275px] w-[389px] bg-white rounded-[10px] max-h-[400px] overflow-y-auto shadow-lg"
      >
        <div className="px-4 py-3 ml-1 border-b text-[17px] font-semibold text-[#232323]">
          Select contractor to create work order
        </div>
        <div className="divide-y">
          {contractors.map((contractor, idx) => (
            <div
              key={idx}
              className="px-4 py-3 cursor-pointer hover:bg-gray-100"
              onClick={() => {
                handleOpenWorkOrder(contractor);
              }}
            >
              <p className="font-medium text-[15px] text-black">
                {contractor.name} 
              </p>
              <p className="text-[14px] text-black">
                {contractor.contractor_type}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorkOrder;
